<template>
  <form-dialog
    v-model="isActive"
    max-width="700px"
    :sending="sending"
    :title="edit ? $t('convenzioni.azioni.modifica') :  $t('convenzioni.azioni.nuovo')"
    @confirm="onConfirm">

    <v-flex xs12>
      <icon-label icon="business" color="accent">{{ $t('convenzioni.label.dati_convenzione') }}</icon-label>
    </v-flex>

    <v-flex xs12 sm6>
      <text-field :label="$t('label.nome')" v-model="form.nome" required/>
    </v-flex>

    <v-flex xs12 sm6>
      <phone-field :label="$t('label.telefono')" v-model="form.telefono" show-details/>
    </v-flex>

    <v-flex xs12 class="mt-4">
      <icon-label icon="location_on" color="accent">{{ $t('label.indirizzo') }}</icon-label>
    </v-flex>

    <v-flex xs12>
      <indirizzo-select
        :paese.sync="form.nazione"
        :regione.sync="form.regione"
        :provincia.sync="form.provincia"
        :comune.sync="form.comune"
        :cap.sync="form.cap"
        :frazione.sync="form.frazione"
        :via.sync="form.via"
        :numero-civico.sync="form.numero_civico"
        show-frazione/>
    </v-flex>

  </form-dialog>
</template>

<script>
import Sendable from '@/mixins/sendable'
import FormDialog from '@/components/base/FormDialog'
import { IndirizzoSelect, PhoneField } from './inputs'

export default {
    name: 'ConvenzioneDialog',
    mixins: [Sendable],
    components: { FormDialog, IndirizzoSelect, PhoneField },
    data () {
        return {
            defaultData: this.$schemas().convenzione
        }
    },
    methods: {
        action () {
            if (this.edit) {
                return this.$api.convenzioni.update(this.form.id, this.form)
            } else {
                return this.$api.convenzioni.create(this.form)
            }
        },
        onConfirm () {
            this.sending = true
            this.action().then(() => {
                this.onSuccess(this.edit ? this.$t('convenzioni.messaggi.modificato') : this.$t('convenzioni.messaggi.creato'))
            }).catch(e => {
                if (e.response && e.response.data && e.response.status === 400) {
                    if (e.response.data.message === 'regenerate') {
                        this.sending = false
                        let vue = this
                        //  E' già stata creata una convenzione con questo nome, mostro la conferma di ripristino
                        this.$confirmDialog.show(
                            this.form.nome,
                            this.$t('convenzioni.messaggi.conferma_ripristino_duplicato'),
                            function (nome) {
                                this.$api.convenzioni.restore(nome).then(() => {
                                    vue.onSuccess(this.$t('convenzioni.messaggi.ripristinato'))
                                })
                            }, { confirmText: this.$t('azioni.ripristina'), color: 'error' })
                    } else if (e.response.data.message === 'used') {
                        this.onError(this.$t('convenzioni.errori.nome_duplicato'))
                    } else {
                        this.onError(this.$t('errori.server'))
                    }
                } else {
                    this.onError(this.$t('errori.server'))
                }
            })
        }
    }
}
</script>
